import { useState, useEffect, useContext } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import EventConfiguration from "./sections/EventConfiguration";
import ExperienceSettings from "./sections/ExperienceSettings";
import AutomationSettings from "./sections/AutomationSettings";
import EventAccess from "./sections/EventAccess";
import PitchSettings from "./sections/PitchSettings";
import { EventContext } from "../../../../contexts/EventContext";
import request from "../../../../utilities/requests";
import { toast } from "../../../../utilities/SnackBarUtils";

const Settings = () => {
  const { pairingEvent, setPairingEvent, userData } = useContext(EventContext);

  const [settings, setSettings] = useState({
    photoRequired: false,
    showGuestList: false,
    autoFillGroups: false,
    showNotebook: false,
    waitListEnabled: false,
    autoComplete: false,
    autoCompleteAfter: "",
    autoCompleteMode: "minutes",
    autoCompleteTime: "",
    autoSendMatches: false,
    display: false,
    breakAfter: 0,
    pitches: {
        enabled: false,
        voting: false
    }
  });

  useEffect(() => {
    if (!pairingEvent) return;
    setSettings({
      photoRequired: pairingEvent?.event?.photoRequired,
      showGuestList: pairingEvent?.event?.showGuestList,
      autoFillGroups: pairingEvent?.event?.autoFillGroups,
      showNotebook: pairingEvent?.event?.showNotebook,
      waitListEnabled: pairingEvent?.event?.waitListEnabled,
      autoComplete: pairingEvent?.event?.autoComplete,
      autoCompleteAfter: pairingEvent?.event?.autoCompleteAfter || "",
      autoSendMatches: pairingEvent?.event?.autoSendMatches,
      autoCompleteMode: pairingEvent.event.autoCompleteMode || "time",
      autoCompleteTime: pairingEvent.event.autoCompleteTime || "",
      display: pairingEvent?.event?.display,
      trackIsPresent: pairingEvent?.event?.trackIsPresent,
      breakAfter: pairingEvent?.event?.breakAfter || 0,
      pitches: pairingEvent?.event?.pitches || {enabled: false, voting: false}
    });
  }, [pairingEvent]);

  const handleChange = async (field, value) => {
    // Optimistically update state immediately
    setSettings((prev) => {
  if (field.includes(".")) {
    const [parent, child] = field.split(".");
    return {
      ...prev,
      [parent]: {
        ...prev[parent],
        [child]: value,
      },
    };
  }

  return { ...prev, [field]: value };
});

    try {
      const body = {
        eventId: pairingEvent.event._id,
        update: { [field]: value },
      };
      const result = await request("events/update", "post", body);
      if (!result.success) {
        toast.error(`Error updating event details: ${result.error}`);
        setSettings((prev) => ({
          ...prev,
          [field]: pairingEvent.event[field],
        }));
      } else {
        toast.success("Setting updated!");
      }
    } catch (e) {
      console.error(`Error updating event details: ${e.message}`);
      toast.error(`Network error updating event details`);
      setSettings((prev) => ({ ...prev, [field]: pairingEvent.event[field] }));
    }
  };
  return (
    <Box sx={{ px: { xs: 0, sm: 3 }, py: { xs: 0, sm: 3 } }}>
      <Paper
        sx={{
          p: { xs: 2, sm: 4 },
          borderRadius: { xs: 0, sm: 2 },
        }}
      >
        <Typography variant="h6" sx={{ mb: 3 }}>
          Event Settings
        </Typography>

        <Box sx={{ mb: 5 }}>
          <EventConfiguration handleChange={handleChange} />
        </Box>

        <Grid container spacing={4}>
          <Grid item md={12} lg={6}>
            <ExperienceSettings
              settings={settings}
              handleChange={handleChange}
            />
          </Grid>

          <Grid item md={12} lg={6}>
            <AutomationSettings
              settings={settings}
              handleChange={handleChange}
            />
          </Grid>

          <Grid item md={12} lg={6}>
            <EventAccess settings={settings} handleChange={handleChange} />
          </Grid>
          <Grid item md={12} lg={6}>
            <PitchSettings settings={settings} handleChange={handleChange} />
          </Grid>
        </Grid>

        {/* 
          ADMIN / ADVANCED SETTINGS
          Rarely used controls such as invoice status, debugging info,
          or other administrative functionality.
        */}
        <Box sx={{ mt: 5 }}>{/* <AdvancedSettings /> */}</Box>
      </Paper>
    </Box>
  );
};

export default Settings;
